import { Suspense, lazy } from "react";
import { Navigate } from "react-router";
import LoadingScreen from "./components/LoadingScreen";
import NotFound from "src/pages/NotFound";
import HomePage from "src/pages/Home";
import TestPage from "src/pages/Test";
import TestForm from "src/pages/Form";
import constants from "./constants";
import Graph from "./components/Graph/Graph";

export interface routeProps {
  path: string;
  Component: any;
}

const routes: routeProps[] = [
  {
    path: "/",
    Component: (
      <Navigate
        to={`/${constants.routeToPlan}?zipcode=77005`}
      />
    ),
  },
  {
    path: "/:planType",
    Component: <HomePage />,
  },

  {
    path: "/comparison-plan",
    Component: <Graph />,
  },

  {
    path: "/test",
    Component: <TestPage />,
  },
  {
    path: "/test-form",
    Component: <TestForm />,
  },
  {
    path: "*",
    Component: <h2>Not Found</h2>,
    // Component: <NotFound/>
  },
];

export default routes;
